import { render, staticRenderFns } from "./ServiceColorPicker.vue?vue&type=template&id=26e1c358&scoped=true&"
import script from "./ServiceColorPicker.vue?vue&type=script&lang=js&"
export * from "./ServiceColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ServiceColorPicker.vue?vue&type=style&index=0&id=26e1c358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e1c358",
  null
  
)

export default component.exports